import { useTranslation } from "react-i18next";
import { ACCESS_CONTROL, ALARMS, CCTV, FIRE_PROTECTION, INSTALLATIONS, NETWORKS, toGallery } from "../../../slides";
import { ItemRenderer } from "../../Start/Start";
import ReactImageGallery from "react-image-gallery";
import "./Realizations.css";
import installationsIcon from "../../../assets/png/icons/installation-icon.png";
import alarmIcon from "../../../assets/png/icons/alarm-icon.png";
import cctvIcon from "../../../assets/png/icons/cctv-icon.png";
import fireIcon from "../../../assets/png/icons/fire-icon.png";
import accessIcon from "../../../assets/png/icons/access-icon.png";
import networkIcon from "../../../assets/png/icons/network-icon.png";
import access_control from '../../../assets/png/access-control.jpg';
import alarms from '../../../assets/png/alarms.jpg';
import cctv_new from '../../../assets/png/cctv.jpg';
import fire_protection from '../../../assets/png/fireprotection.jpg';
import installations_new from '../../../assets/png/installations.jpg';
import networks from '../../../assets/png/networks.jpg';
import { Contact } from "../../Contact/Contact";
import { NavLink } from "react-router-dom";

export const SERVICES = [
  {
    img: installations_new,
    title: "start.services.installations",
    items: toGallery(INSTALLATIONS),
    icon: installationsIcon,
    path: "/installations",
    description: {
      pl: "Klasyczne instalacje, smart home, modernizacje elektryczne, serwisy.",
      en: "Classic installations, smart home, electrical upgrades, services.",
    }
  },
  {
    img: alarms,
    title: "start.services.alarms",
    items: toGallery(ALARMS),
    icon: alarmIcon,
    path: "/alarms",
    description: {
      pl: "Od prostych zabezpieczeń, przez rozbudowane realizacje, po integracje służące automatyce budynkowej.",
      en: "From simple security systems to advanced implementations and integrations for building automation.",
    }
  },
  {
    img: cctv_new,
    title: "start.services.cctv",
    items: toGallery(CCTV),
    icon: cctvIcon,
    path: "/cctv",
    description: {
      pl: "Rozwiązania klasyczne, systemy z analizą obrazu, systemy wizyjne perymetrycznej ochrony terenu.",
      en: "Classic solutions, image analysis systems, perimeter protection video systems.",
    }
  },
  {
    img: access_control,
    title: "start.services.access_control",
    items: toGallery(ACCESS_CONTROL),
    icon: accessIcon,
    path: "/access_control",
    description: {
      pl: "Domofony, wideodomofony IP, klasyczna kontrola dostępu, rejestracja czasu pracy.",
      en: "Intercoms, IP video intercoms, classic access control, time registration.",
    }
  },
  {
    img: fire_protection,
    title: "start.services.fire_protection",
    items: toGallery(FIRE_PROTECTION),
    icon: fireIcon,
    path: "/fire_protection",
    description: {
      pl: "Oddymianie grawitacyjne, dźwiękowe systemy ostrzegawcze, systemy sygnalizacji pożaru.",
      en: "Gravity smoke extraction, sound warning systems, fire alarm systems.",
    }
  },
  {
    img: networks,
    title: "start.services.networks",
    items: toGallery(NETWORKS),
    icon: networkIcon,
    path: "/networks",
    description: {
      pl: "Sieci MESH AP, zarządzaniem siecią VLAN, SD-WAN.",
      en: "MESH AP networks, VLAN network management, SD-WAN.",
    }
  }
];

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

interface Service {
  title: string,
  description: string,
  services: string[],
  uses: string
}

export function Realizations({ service }: { service: ArrayElement<typeof SERVICES> }) {
  const { i18n } = useTranslation();

  const services: Service[] = i18n.t("services", { returnObjects: true });
  const index = SERVICES.findIndex(s => service === s);
  const otherServices = SERVICES.filter((s, i) => i !== index);
  const combined = {
    ...service,
    translation: services[index]
  };
  return <div className="Realizations">
    <div className='content'>
      <div className='service-description-section-title section-title'>
        <img src={combined.icon} alt={i18n.t(combined.title)} />
        <div>{i18n.t(combined.title)}</div>
      </div>
      <section id="description">
        {combined.translation.description}
        <ul>
          {combined.translation.services.map(s => <li>{s}</li>)}
        </ul>
        {combined.translation.uses}
      </section>
      <ReactImageGallery
        items={combined.items}
        infinite={true}
        showNav={true}
        showFullscreenButton={true}
        showPlayButton={true}
        showBullets={true}
        autoPlay={true}
        renderItem={(p) => <ItemRenderer {...p}></ItemRenderer>}
        additionalClass='custom-gallery'
      />

      <div className='section-title'>{i18n.language === "en" ? "See also" : "Zobacz również"}</div>
      <div className="see-also">
        {otherServices.map(s => <NavLink to={s.path}>
          <img src={s.icon} alt={i18n.t(s.title)} />
          <div>{i18n.t(s.title)}</div>
        </NavLink>)}
      </div>

      <div className='section-title'>{i18n.t("menu.contact")}</div>
      <Contact></Contact>
    </div>
  </div>;
}